import React, { useState } from "react";
import { DatePicker } from "antd";
import { Button, Modal, Tooltip } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en";
import { FullscreenOutlined } from "@ant-design/icons";

import isBetween from "dayjs/plugin/isBetween";
import { HeatMapView } from "./HeatMap";
import { StandCountCard } from "./StandCountCard";
import { showHeatMapOnBroccoliDashboard } from "../../../consts/config";

dayjs.extend(isBetween);

const { RangePicker } = DatePicker;

const StandCountDashboardContent = ({
  currentOrg,
  currentSite,
  dateList,
  siteMetadata,
  currentCrop,
  currentGreenhouse,
  currentPlot,
}) => {
  const [isHeatmapFullscreenOpen, setIsHeatmapFullscreenOpen] = useState(false);
  const fullscreenInset = "clamp(8px, 2.2vw, 24px)";
  const fullscreenWrapperPadding = "clamp(4px, 1.1vw, 12px)";

  const areaUnit = currentSite?.metadata?.siteConfig?.units?.area === "acre" ? "acre" : "Hectare";

  return (
    <>
      {/* Percentage Calculator Section */}
      <StandCountCard
        areaUnit={areaUnit}
        siteMetadata={siteMetadata}
        currentCrop={currentCrop}
        currentGreenhouse={currentGreenhouse}
        currentPlot={currentPlot}
      />

      {/* HeatMap Section */}
      {showHeatMapOnBroccoliDashboard && (
        <>
          <HeatMapView
            currentOrg={currentOrg}
            currentSite={currentSite}
            siteMetadata={siteMetadata}
            currentCrop={currentCrop}
            currentGreenhouse={currentGreenhouse}
            currentPlot={currentPlot}
            dateList={dateList}
            fullscreenAction={
              <Tooltip title="Open fullscreen">
                <Button
                  type="text"
                  aria-label="Open heatmap in fullscreen"
                  icon={<FullscreenOutlined />}
                  onClick={() => setIsHeatmapFullscreenOpen(true)}
                  className="!h-8 !w-8 !p-0 !text-primaryBlue"
                />
              </Tooltip>
            }
          />

          <Modal
            open={isHeatmapFullscreenOpen}
            onCancel={() => setIsHeatmapFullscreenOpen(false)}
            footer={null}
            title={null}
            width={`calc(100% - ${fullscreenInset})`}
            centered={true}
            destroyOnHidden={true}
            styles={{
              wrapper: {
                overflow: "hidden",
                padding: fullscreenWrapperPadding,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              body: {
                padding: 0,
                height: `calc(100dvh - ${fullscreenInset})`,
                overflow: "hidden",
              },
              content: {
                padding: 0,
                height: `calc(100dvh - ${fullscreenInset})`,
                overflow: "hidden",
              },
            }}
            style={{
              paddingBottom: 0,
              maxWidth: "none",
              margin: "0 auto",
            }}
            className="!max-w-none"
          >
            <div className="h-full min-h-0 overflow-hidden p-2 lg:p-1.5 md:p-1 sm:p-0.5">
              <HeatMapView
                currentOrg={currentOrg}
                currentSite={currentSite}
                siteMetadata={siteMetadata}
                currentCrop={currentCrop}
                currentGreenhouse={currentGreenhouse}
                currentPlot={currentPlot}
                dateList={dateList}
                isFullscreen={true}
              />
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default StandCountDashboardContent;
